export const PROD_S3_URL = "https://stand-consult-public.s3.amazonaws.com/standoccaz.json";
export const TEST_S3_URL = "https://stand-consult-public.s3.amazonaws.com/standoccaz-test.json";
export const DEFAULT_S3_URL = TEST_S3_URL;
